module.exports = __webpack_public_path__ + "static/media/k5-alt-texture-transparent.c51f7589.png";